<script>
import { mapGetters, mapActions } from 'vuex';
import CryptoJS from 'crypto-js';

export default {
  data() {
    return {
      isLoading: true,
      token: '',
      baseUrl: process.env.VUE_APP_BACKEND_URL || '',
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      agents: 'agents/getAgents',
    }),
    firstAdminAccount() {
      return this.agents.find(agent => agent.role === 'administrator');
    },
    userEmail() {
      return this.firstAdminAccount?.length
        ? this.firstAdminAccount[0]
        : this.currentUser?.email;
    },
  },
  async mounted() {
    await this.getAgents();
    this.generateToken();
  },
  methods: {
    ...mapActions({
      getAgents: 'agents/get',
    }),
    hideLoader() {
      this.isLoading = false;
    },
    generateToken() {
      const payload = {
        email: this.userEmail,
        timestamp: Date.now(),
      };

      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(payload),
        process.env.VUE_APP_JWT_SECRET
      );

      this.token = encrypted.toString();
    },
  },
};
</script>

<template>
  <div class="conbot-iframe-container">
    <div v-if="isLoading" class="loader-container">
      <div class="loader" />
    </div>
    <iframe
      :src="`${baseUrl}/signin?token=${encodeURIComponent(token)}`"
      width="100%"
      height="600px"
      frameborder="0"
      @load="hideLoader"
    />
  </div>
</template>

<style scoped>
.conbot-iframe-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

iframe {
  border: none;
  width: 100%;
  height: 100vh;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

iframe::-webkit-scrollbar {
  display: none;
}

.loader-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
